const groups = [
  {
    icon: 'ri-funds-line',
    title: 'Отдел продаж',
    desc: 'Техники продаж, работа с возражениями, переговоры, увеличение среднего чека, кросс-продажи. Обучение отдела продаж напрямую влияет на выручку.',
    priority: 'Окупается быстрее всего'
  },
  {
    icon: 'ri-shield-star-line',
    title: 'Руководители',
    desc: 'Управление командой, делегирование, мотивация, стратегическое мышление, принятие решений. Тренинг для руководителей закрывает ключевой разрыв между «специалистом» и «управленцем».',
    priority: 'Системный эффект на всю команду'
  },
  {
    icon: 'ri-team-line',
    title: 'HR-специалисты',
    desc: 'Современные технологии подбора, адаптации, оценки и развития персонала. HR как бизнес-партнёр, а не «отдел кадров».',
    priority: 'Усиливает HR-функцию'
  },
  {
    icon: 'ri-megaphone-line',
    title: 'Маркетинг',
    desc: 'Цифровой маркетинг, аналитика, контент-стратегия, работа с данными. Маркетинг, который приносит измеримые лиды.',
    priority: 'Рост воронки продаж'
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Сервис и поддержка',
    desc: 'Работа с жалобами, сложные клиенты, стандарты обслуживания, эмпатия. Сервис — главное конкурентное преимущество.',
    priority: 'Влияет на NPS и удержание'
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Производство',
    desc: 'Бережливое производство, стандарты качества, безопасность, работа с оборудованием. Снижение брака и повышение эффективности.',
    priority: 'Прямая экономия'
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Back Office',
    desc: 'Финансы, бухгалтерия, юристы, административный персонал. Автоматизация, цифровые инструменты, soft skills.',
    priority: 'Эффективность процессов'
  },
  {
    icon: 'ri-user-line',
    title: 'Линейный персонал',
    desc: 'Стандарты работы, скрипты общения, продуктовая экспертиза. Фундамент качества сервиса и операционной эффективности.',
    priority: 'Массовый эффект'
  },
  {
    icon: 'ri-rocket-line',
    title: 'Новые сотрудники',
    desc: 'Адаптация новых сотрудников: продукт, процессы, культура компании. Onboarding сокращает время выхода на плановые показатели в 2-3 раза.',
    priority: 'Быстрый старт'
  },
  {
    icon: 'ri-star-line',
    title: 'Высокопотенциальные сотрудники',
    desc: 'HiPo: индивидуальные планы развития, менторство, стратегические проекты. Подготовка будущих лидеров компании.',
    priority: 'Кадровый резерв'
  }
];

export default function WhoNeedsTraining() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Какие сотрудники нуждаются в обучении
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          В обучении нуждаются все — от линейного персонала до топ-менеджмента. Но у каждой группы свои задачи и свои форматы.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {groups.map((g, i) => (
            <div key={i} className="bg-gray-50 rounded-2xl p-6 border border-gray-100 hover:border-teal-200 hover:shadow-md transition-all group">
              <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <i className={`${g.icon} text-xl text-white`}></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2 text-sm">{g.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed mb-3">{g.desc}</p>
              <div className="bg-teal-50 rounded-lg px-3 py-1.5 inline-block">
                <span className="text-xs font-semibold text-teal-700">{g.priority}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}